import React, { useState, useRef, forwardRef } from 'react'
import { IconButton, Popover, useTheme } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import SettingsIcon from '@mui/icons-material/Settings'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import WidgetBase from './WidgetBase'

const WidgetContainer = forwardRef((props, ref) => {
  const { widgetId, editable, renderSettings, onRemove, disabled, children, onClick, x, y, w, h, minW, minH, title, icon, preview, widgetProviderInfo, status, header, isClickable } = props
  const [settingsOpen, setSettingsOpen] = useState(false)
  const settingsButtonRef = useRef(null)
  const theme = useTheme()
  const { t_ } = useSmartTranslation()

  return (
    <div
      ref={ref}
      key={widgetId}
      className='grid-stack-item'
      data-id={widgetId}
      gs-x={x}
      gs-y={y}
      gs-w={w}
      gs-h={h}
      gs-min-w={minW}
      gs-min-h={minH}
      gs-max-w={widgetProviderInfo?.maxW}
      gs-max-h={widgetProviderInfo?.maxH}
      style={{
        outline: editable ? 'solid 3px ' + theme.palette.primary.light : undefined,
        borderRadius: editable ? '24px' : undefined,
        height: '100%',
        padding: '0.40rem',
        transition: 'all 0.3s ease',
        cursor: isClickable ? 'pointer' : undefined
      }}
    >
      {renderSettings && editable
        ? (
          <Popover
            open={settingsOpen}
            anchorEl={settingsButtonRef.current}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={() => setSettingsOpen(false)}
          >{renderSettings}
          </Popover>
          )
        : null}
      <div
        style={{ position: 'relative', height: '100%', width: '100%', overflow: 'initial' }}
        onClick={onClick}
        className='grid-stack-item-content' // IMPORTANT: Needed for GridStack
      >
        {editable
          ? (
            <div style={{ position: 'absolute', right: -4, top: -4, zIndex: 100 }}>
              <IconButton onClick={onRemove} size='small' sx={{ backgroundColor: 'background.paper', boxShadow: 2, '&:hover': { backgroundColor: 'error.light' } }}>
                <DeleteIcon color='error' fontSize='small' />
              </IconButton>
            </div>)
          : null}
        {renderSettings && editable
          ? (
            <div style={{ position: 'absolute', top: -4, left: -4, zIndex: 100 }}>
              <IconButton ref={settingsButtonRef} onClick={() => setSettingsOpen(!settingsOpen)} size='small' sx={{ backgroundColor: 'background.paper', boxShadow: 2 }}>
                <SettingsIcon fontSize='small' />
              </IconButton>
            </div>)
          : null}
        <div style={{ width: '100%', height: '100%', pointerEvents: editable || disabled ? 'none' : 'auto' }}>
          <WidgetBase
            title={t_(title)}
            icon={icon}
            hideHeader={!preview && widgetProviderInfo.hideHeader}
            status={status}
            header={header}
            isClickable={isClickable}
          >
            {children}
          </WidgetBase>
        </div>
      </div>
    </div>
  )
})

export default WidgetContainer
